'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var iterator = require('@ipld/car/iterator');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var itPeekable = require('it-peekable');

var drain = require('it-drain');

var map = require('it-map');

var debug = require('debug');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var itPeekable__default = /*#__PURE__*/_interopDefaultLegacy(itPeekable);

var drain__default = /*#__PURE__*/_interopDefaultLegacy(drain);

var map__default = /*#__PURE__*/_interopDefaultLegacy(map);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:components:dag:import');

function createImport(_ref) {
  var repo = _ref.repo;

  function dagImport(_x) {
    return _dagImport.apply(this, arguments);
  }

  function _dagImport() {
    _dagImport = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sources) {
      var options,
          release,
          abortOptions,
          peekable,
          _yield$_awaitAsyncGen,
          value,
          done,
          cars,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          car,
          roots,
          _iterator2,
          _step2,
          cid,
          pinErrorMsg,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return _awaitAsyncGenerator(repo.gcLock.readLock());

            case 3:
              release = _context.sent;
              _context.prev = 4;
              abortOptions = {
                signal: options.signal,
                timeout: options.timeout
              };
              peekable = itPeekable__default["default"](sources);
              _context.next = 9;
              return _awaitAsyncGenerator(peekable.peek());

            case 9:
              _yield$_awaitAsyncGen = _context.sent;
              value = _yield$_awaitAsyncGen.value;
              done = _yield$_awaitAsyncGen.done;

              if (!done) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return");

            case 14:
              if (value) {
                peekable.push(value);
              }

              if (value instanceof Uint8Array) {
                cars = [peekable];
              } else {
                cars = peekable;
              }

              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 18;
              _iterator = _asyncIterator(cars);

            case 20:
              _context.next = 22;
              return _awaitAsyncGenerator(_iterator.next());

            case 22:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 64;
                break;
              }

              car = _step.value;
              _context.next = 26;
              return _awaitAsyncGenerator(importCar(repo, abortOptions, car));

            case 26:
              roots = _context.sent;

              if (!(options.pinRoots !== false)) {
                _context.next = 61;
                break;
              }

              _iterator2 = _createForOfIteratorHelper(roots);
              _context.prev = 29;

              _iterator2.s();

            case 31:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 53;
                break;
              }

              cid = _step2.value;
              pinErrorMsg = '';
              _context.prev = 34;
              _context.next = 37;
              return _awaitAsyncGenerator(repo.blocks.has(cid));

            case 37:
              if (!_context.sent) {
                _context.next = 43;
                break;
              }

              log("Pinning root ".concat(cid));
              _context.next = 41;
              return _awaitAsyncGenerator(repo.pins.pinRecursively(cid));

            case 41:
              _context.next = 44;
              break;

            case 43:
              pinErrorMsg = 'blockstore: block not found';

            case 44:
              _context.next = 49;
              break;

            case 46:
              _context.prev = 46;
              _context.t0 = _context["catch"](34);
              pinErrorMsg = _context.t0.message;

            case 49:
              _context.next = 51;
              return {
                root: {
                  cid: cid,
                  pinErrorMsg: pinErrorMsg
                }
              };

            case 51:
              _context.next = 31;
              break;

            case 53:
              _context.next = 58;
              break;

            case 55:
              _context.prev = 55;
              _context.t1 = _context["catch"](29);

              _iterator2.e(_context.t1);

            case 58:
              _context.prev = 58;

              _iterator2.f();

              return _context.finish(58);

            case 61:
              _iteratorAbruptCompletion = false;
              _context.next = 20;
              break;

            case 64:
              _context.next = 70;
              break;

            case 66:
              _context.prev = 66;
              _context.t2 = _context["catch"](18);
              _didIteratorError = true;
              _iteratorError = _context.t2;

            case 70:
              _context.prev = 70;
              _context.prev = 71;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 75;
                break;
              }

              _context.next = 75;
              return _awaitAsyncGenerator(_iterator.return());

            case 75:
              _context.prev = 75;

              if (!_didIteratorError) {
                _context.next = 78;
                break;
              }

              throw _iteratorError;

            case 78:
              return _context.finish(75);

            case 79:
              return _context.finish(70);

            case 80:
              _context.prev = 80;
              release();
              return _context.finish(80);

            case 83:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4,, 80, 83], [18, 66, 70, 80], [29, 55, 58, 61], [34, 46], [71,, 75, 79]]);
    }));
    return _dagImport.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(dagImport);
}

function importCar(_x2, _x3, _x4) {
  return _importCar.apply(this, arguments);
}

function _importCar() {
  _importCar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(repo, options, source) {
    var reader, roots;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return iterator.CarBlockIterator.fromIterable(source);

          case 2:
            reader = _context2.sent;
            _context2.next = 5;
            return reader.getRoots();

          case 5:
            roots = _context2.sent;
            _context2.next = 8;
            return drain__default["default"](repo.blocks.putMany(map__default["default"](reader, function (_ref2) {
              var key = _ref2.cid,
                  value = _ref2.bytes;
              log("Import block ".concat(key));
              return {
                key: key,
                value: value
              };
            }), {
              signal: options.signal
            }));

          case 8:
            return _context2.abrupt("return", roots);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _importCar.apply(this, arguments);
}

exports.createImport = createImport;